import { Capacitor } from "@capacitor/core";
import { logEvent as webLogEvent } from "firebase/analytics";
import { FirebaseAnalytics } from "@capacitor-community/firebase-analytics";
import { analytics } from "./firebase";

const isNative = Capacitor.isNativePlatform();

/**
 * One tracking call that works everywhere:
 * - Web  → Firebase JS SDK (getAnalytics / logEvent), GA4 stream G-P1SE2D19WK
 * - iOS/Android → @capacitor-community/firebase-analytics native plugin
 *
 * Analytics must never break the app, so every call is wrapped defensively.
 */
export const track = (name: string, params: Record<string, any> = {}) => {
  try {
    if (isNative) {
      FirebaseAnalytics.logEvent({ name, params });
    } else if (analytics) {
      webLogEvent(analytics, name, params);
    }
  } catch {
    /* ignore analytics errors */
  }
};

/** Screen view — native only; web page_view is auto-collected by getAnalytics(). */
export const trackScreen = (screenName: string) => {
  try {
    if (isNative) {
      FirebaseAnalytics.setScreenName({ screenName, nameOverride: screenName });
    }
  } catch {
    /* ignore analytics errors */
  }
};
